<template>
  <div class="FinalizePaymentBonus">
    <underlined-heading color="orange">Успешно извършено плащане с МПС Експерт Бонус Кредити!</underlined-heading>
    <div class="row">
      <div class="column w-48">
        <img
          src="@/assets/images/payments/bonus_logo.png"
          alt=""
        >
      </div>
      <div class="column">
        <div>
          Ти закупи <strong>{{ orderData.purchase.tickets.length }}</strong> билет/а за Тур:
          <router-link :to="{ name: 'round', params: { id: round.id } }" class="text-red"> {{ round.name }} </router-link>, на стойност
          {{ orderData.credits_used }} МПС Eксперт Бонус Кредита. В профила си имаш още {{ orderData.credits_left }} МПС
          Eксперт Бонус Кредита.
        </div>
        <div>
          Отиди на <router-link :to="{ name: 'profile.view' }" class="text-red">своя профил</router-link>, за да видиш история на своите поръчки.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UnderlinedHeading from '@/components/core/UnderlinedHeading'

/**
 * @module FinalizePaymentBonus
 */
export default {
  name: 'FinalizePaymentBonus',
  components: { UnderlinedHeading },
  props: {
    orderData: {
      type: Object,
      required: true
    }
  },
  computed: {
    round () {
      return this.orderData.purchase ? this.orderData.purchase.round : null
    }
  }
}
</script>

<style lang='scss'>
@import '~utils';

</style>
